import React from 'react'

const LocationSelector = (props) => (
  <div className='location-container'>
    <select className='search-input location-select' value={props.location} onChange={ev => props.changeLocation(ev.target.value)}>
      <option value='Barcelona'>Barcelona</option>
      <option value='Sofia'>Sofia</option>
      <option value='Madrid'>Madrid</option>
      <option value='Amsterdam'>Amsterdam</option>
      <option value='Herzogenaurach'>Herzogenaurach</option>
    </select>
  </div>
)

export default LocationSelector



// WEBPACK FOOTER //
// ./src/screens/administration/LocationSelector.js